<template>
  <div class="flexPanel spaceBetween basePanel">
      <div :class="{taskCard:true,focusCard:isFocus(item)}"  @click="changeCardFocus(item)" v-for="item in taskSource" :key="item.ID">
        <div class="flexPanel taskCardContent" @contextmenu="rowContextmenu(item)">
          <!--<el-col :span="2">-->
					<vue-context-menu :contextMenuData="contextMenuData" @createdTalk="$emit('createdTalk')" @urgeTask="$emit('urgeTask')" @addWorkRecord="$emit('addWorkRecord')"
					@focusTask="$emit('focusTask')" @TaskSummary="$emit('TaskSummary')" @Notification="$emit('Notification')"></vue-context-menu>
          <!-- <el-checkbox class="chk" @change="changeCardSelect(item.ID)"/> -->
          <!--</el-col>-->
          <!--<el-col :span="20">-->
          <div class="rightPanel">
            <span class="nameSpan">{{item.TASKNAME}}</span>
            <div class="flexPanel  spaceBetween bottomPanel" >
              <div class="floatPanel leftPanel">
                <div class="flexPanel">
                  <span>状态:</span>
                  <el-tag :type="item.STATE|taskStateFormater">{{item.TASKSTATENAME}}</el-tag>
                </div>
                <div class="flexPanel">
                  <span> 编号:</span>
                  <el-tag >{{item.INSTANCE}}</el-tag>
                </div>
              </div>
              <div class="userSpan" v-show="item.EXCUTEUSERNAME">
                {{item.EXCUTEUSERNAME|nameSpliceFormater}}
              </div>
            </div>

            <!--</el-col>-->
          </div>
        </div>
      </div>
  </div>
</template>

<script>
	import { ConstTask } from "@/api/modules/basicData/task.js"
  import { getTaskByTaskId } from "@/api/modules/basicData/task.js"
  export default {
    name: "TaskCardList",
		props: {
			contextMenuData: {
				type: Object,
				require: true
			},
		},
    data(){
      return {
        multipleSelection: [],
      }
    },
    computed: {
      taskSource: function () {
        return this.$store.state.task.taskSource;
      },
      curTask:function () {
        return this.$store.state.task.curTask;
      }
    },
    methods:{
      changeCardSelect(val,row){
        if(val)
        {
          if(this.multipleSelection.indexOf(row)>0)
            this.multipleSelection.push(row);
        }
        else {
          let index =  this.multipleSelection.indexOf(row);
          if (index > -1) {
            this.multipleSelection.splice(index, 1);
          }
        }
      },
      changeCardFocus(row){
        this.$store.dispatch('changeCurTask',row);
        this.$store.dispatch('changeTaskDetailShow',true);
      },
      isFocus(row){
        if(!row) return false;
        if(!this.curTask) return false;
        return row.ID===this.curTask.ID;
      },
			rowContextmenu(row){
				event.preventDefault()
				this.$emit('rowContextmenu',{
					x: event.clientX,
					y: event.clientY,
					data: row
				})
			},
    },
    filters:{
      taskStateFormater:function (val) {
        switch (val) {
          case 0:
            return 'danger';
          case 1:
            return 'success';
          case 2:
            return '';
          case -1:
            return 'warning';
          default:
            return 'info';
        }
      },
      nameSpliceFormater:function (val) {
        if(!val) return '';
        return val.substr(1,2);
      }
    }
  }
</script>

<style scoped>
  .taskCardContent{
    width: 290px;
    height: 127px;
  }
  .taskCard {
    height: 132px;
    margin-left: 5px;
    margin-bottom: 15px;
    margin-right: 10px;
    border-radius:10px ;
    border: 1px solid azure;
    padding:5px 10px 20px;
    box-shadow:#bebebe 0 0 12px ;
  }
.bottomPanel{
  margin-top: 10px;
}
.basePanel{
  width: 100%;
}
.focusCard{
  box-shadow: dodgerblue 0 0 18px!important; ;
}
  .userSpan{
    width: 39px;
    height: 39px;
    display: flex;
    justify-content:center;
    align-items:Center;
    background-color: #2dbcff;
    border-radius:50%;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    color: #ffffff;
  }
  el-checkbox{
    margin-left: 5px;
  }
  .nameSpan{
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    text-align: left;
    -webkit-box-orient: vertical;
    font-size: 17px;
    color: #282828;

    font-weight: bolder;
  }
  .flexPanel{
    display: flex;
    padding-top: 5px;
  }
  .floatPanel{
  float: left;
  }
  .leftPanel
  {
    width: 85%;
  }
 .chk{
    margin-right: 10px;
   width: 10%;
   height: 20px;
  }
  .spaceBetween{
    /*justify-content: space-between;*/
    align-content:  flex-start;
    flex-wrap:wrap;
  }
.rightPanel{
  width: 90%;
}
</style>
